export default {
  "header": {
    "notification": {
      "tooltip": "Subscribe to notifications",
      "tooltip_active": "Unsubscribe to notifications"
    },
    "share": {
      "modal_title": "Partager l'accès à",
      "modal_subtitle": "Partager avec",
      "dialog_title": "Partager {name}",
      "dialog_subtitle": "Les membres des espaces de travail activés peuvent ouvrir ce jeu de données, en lecture seule.",
      "empty": "Aucun autre espace de travail de cette organisation avec qui partager.",
      "button": "Terminé",
      "tooltip": "Partagé avec {workspaces}"
    },
    "trigger": {
      "CRON": { "title": "Updated {readable} ({offset})", "subtitle": " Next run {next}", "tooltip": "Cron expression: {cron}" },
      "SCHEDULED": { "title": "Updated {readable} ({offset})", "subtitle": " Next run {next}", "tooltip": "Scheduled trigger" },
      "MANUAL": { "title": "This dataset does not update automatically", "tooltip": "Manual trigger" }
    }
  }
};
